import { isVoidField } from '@formily/core'
import { connect, mapProps } from '@formily/vue'

import type { FormItem as _ElFormItemProps } from '@didi-pebble/pebble-design-vue'
import { FormItem as ElFormItemComponent } from '@didi-pebble/pebble-design-vue'

export type ElFormItemProps = _ElFormItemProps & { title: string }

export const ElFormItem = connect(
  ElFormItemComponent,
  mapProps({ title: 'label', required: true }, (props, field) => ({
    error: !isVoidField(field)
      ? field.errors.length
        ? field.errors.join('，')
        : undefined
      : undefined,
  }))
)

export default ElFormItem
